module.exports = __webpack_public_path__ + "static/img/logoW.ae5f14c4.png";